// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2t_iz","icon":"styles_icon__QDjgg"};